// AUTO-GENERATED by scripts/generate-build-info.js — do not edit.
export const BUILD_INFO = {
  version: "1.0.0",
  gitSha: "e1855efa",
  buildDate: "2026-11-05"
} as const;
